import { render, staticRenderFns } from "./sold-out-setting.vue?vue&type=template&id=6e582edb"
import script from "./sold-out-setting.vue?vue&type=script&lang=js"
export * from "./sold-out-setting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports